import { createFileRoute, useParams } from '@tanstack/react-router'

import { FaceEditScreen } from '@/components/growers/faces/face-edit-screen'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/$faceId',
)({
    component: GrowerFaceEditRoutePage,
})

/**
 * Thêm hoặc sửa một khuôn mặt — surface NHÂN VIÊN.
 *
 * faceId = "new" nghĩa là thêm mới. Dùng một route cho cả hai thay vì hai
 * route riêng: form giống hệt nhau, chỉ khác có sẵn dữ liệu hay chưa.
 */
function GrowerFaceEditRoutePage() {
    const { id, faceId } = useParams({
        from: '/_app/_authed/_sidebar/agriculture/growers/$id_/faces/$faceId',
    })

    return (
        <FaceEditScreen
            growerId={id}
            scope="staff"
            faceId={faceId === 'new' ? undefined : faceId}
        />
    )
}
